import { render, staticRenderFns } from "./PerformanceBreakdown.vue?vue&type=template&id=14e8480c&scoped=true&"
import script from "./PerformanceBreakdown.vue?vue&type=script&lang=js&"
export * from "./PerformanceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e8480c",
  null
  
)

export default component.exports